import * as Sentry from "@sentry/react";

export type SentryUser = {
  id?: string;
  email?: string;
  shadowUser?: boolean;
};

export const sentryService = {
  setUser: (user: SentryUser) => Sentry.setUser(user),
  clearUser: () => Sentry.setUser(null),
  captureException: (
    ...args: Parameters<typeof Sentry.captureException>
  ): ReturnType<typeof Sentry.captureException> =>
    Sentry.captureException(...args),
  captureMessage: (
    ...args: Parameters<typeof Sentry.captureMessage>
  ): ReturnType<typeof Sentry.captureMessage> => Sentry.captureMessage(...args),
};

export type SentryService = typeof sentryService;
